import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { securityService } from "services/SecurityService";
import { getException } from "lib/helpers/errorHelper";
import { MenuItem } from "types";

const name: string = "menu.action";

interface MenuState {
  menu: MenuItem[];
  error: string | any;
  loading: Boolean;
}

const initialState: MenuState = {
  menu: [],
  error: null,
  loading: false,
};

export const getMenu = createAsyncThunk(`${name}/getMenu`, async (email: string, { rejectWithValue }) => {
  try {
    const response = await securityService.getMenu(email);
    return response;
  } catch ({ data }) {
    return rejectWithValue(getException(data));
  }
});

const menuSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getMenu.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getMenu.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.menu = payload;
      state.error = null;
    });

    builder.addCase(getMenu.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
  reducers: {},
});

export default menuSlice.reducer;
